import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const HomeCtaSection = () => (
    <section className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Ready to speed up your transaction</h2>
                <p className="sub">Join 50+ investors, advisors, and companies already using the platform. Start free — no credit card required.</p>
                <div className="lp-cta-btns">
                    <Link className="lp-cta-btn" to={ROUTES.REGISTER}>Get started free</Link>
                    <a className="lp-cta-btn lp-cta-btn--outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Talk to us</a>
                </div>
                <p className="fine">mark.bernstein@diligentsia.co.uk · diligentsia.co.uk</p>
            </div>
        </div>
    </section>
);

export default HomeCtaSection;
